export const EXAMPLE_AUTHTOKEN = {
  appDefId: '671f58af-c729-456a-b89e-5963647becf3',
  demoMode: false,
  expirationDate: '2021-02-04T17:12:37.584Z',
  // ID --> für lokales entwickeln ändern um einen neuen Nutzer zu erzeugen
  instanceId: 'c95fa8b6-03ea-4fcc-9cd1-6eaa4c1da1feadh',
  loginAccountId: '771a0791-98df-4d79-a01c-51c107bf4dd2',
  permissions: 'OWNER',
  signDate: '2021-02-04T13:12:37.584Z',
  siteMemberId: '771a0791-98df-4d79-a01c-51c107bf4dd2',
  siteOwnerId: '771a0791-98df-4d79-a01c-51c107bf4dd2',
  uid: '771a0791-98df-4d79-a01c-51c107bf4dd2',
};

export const EXAMPLE_QUERY_PARAMS = {
  cacheKiller: '1612444358613',
  compId: 'kkqvqlsl',
  consentPolicy: '%7B%22func%22%3A1%2C%22anl%22%3A1%2C%22adv%22%3A0%2C%22dt3%22%3A0%2C%22ess%22%3A1%7D',
  containerProtocol: 'https',
  instance: 'L2WQ1WXCrAejS_gLBBxJj7opU8SLy-rIjyDIK3sX_r8.eyJpbnN0YW5jZUlkIjoiYzk1ZmE4YjYtMDNlYS00ZmNjLTljZDEtNmVhYTRjMWRhMWZlIiwiYXBwRGVmSWQiOiI2NzFmNThhZi1jNzI5LTQ1NmEtYjg5ZS01OTYzNjQ3YmVjZjMiLCJzaWduRGF0ZSI6IjIwMjEtMDItMDRUMTM6MTI6MzcuNTg0WiIsInVpZCI6Ijc3MWEwNzkxLTk4ZGYtNGQ3OS1hMDFjLTUxYzEwN2JmNGRkMiIsInBlcm1pc3Npb25zIjoiT1dORVIiLCJkZW1vTW9kZSI6ZmFsc2UsInNpdGVPd25lcklkIjoiNzcxYTA3OTEtOThkZi00ZDc5LWEwMWMtNTFjMTA3YmY0ZGQyIiwic2l0ZU1lbWJlcklkIjoiNzcxYTA3OTEtOThkZi00ZDc5LWEwMWMtNTFjMTA3YmY0ZGQyIiwiZXhwaXJhdGlvbkRhdGUiOiIyMDIxLTAyLTA0VDE3OjEyOjM3LjU4NFoiLCJsb2dpbkFjY291bnRJZCI6Ijc3MWEwNzkxLTk4ZGYtNGQ3OS1hMDFjLTUxYzEwN2JmNGRkMiJ9',
  isPublish: 'true',
  locale: 'en',
  siteUrl: 'https://www.w11k-dev.com/',
  viewMode: 'dashboard',
};

export const EXAMPLE_PREFILLED_DATA = {
  shopName: 'shopName',
  targetMarket: 'De',
  companyName: 'companyName',
  country: 'DE',
  firstName: 'first Name',
  lastName: 'lastName',
  email: 'fischer@w11k.de',
} as any;
